import { FC, Ref } from 'react';
import styled, { css } from 'styled-components';
import { Select as AntdSelect, SelectProps as AntdSelectProps } from 'antd';
import type { RefSelectProps } from 'antd/lib/select';
import { Suffix } from '../Suffix/Suffix';

interface SelectProps<T = any> extends AntdSelectProps<T> {
  suffix?: string;
  selectRef?: Ref<RefSelectProps>;
}

const StyledSelect = styled(AntdSelect)<SelectProps>`
  font-size: 18px;
  position: relative;

  .ant-select-clear {
    position: absolute;
    top: 7px;
    right: 4px;
    padding: 19px;
    opacity: 100%;
    display: flex;
    justify-content: center;
  }

  .ant-select-arrow {
    margin-right: 40px;
  }

  .ant-select-arrow:last-child {
    margin-right: 0;
  }

  .ant-select-selector {
    ${({ suffix }) =>
      suffix &&
      css`
        border-radius: 4px 0px 0px 4px !important;
        border-right: 0px !important;
        font-size: 18px;
      `}
  }
`;

export function Select<T>(props: SelectProps<T>): JSX.Element {
  const { suffix, selectRef, ...selectProps } = props;
  return (
    <div style={{ display: 'flex' }}>
      <StyledSelect<FC<SelectProps<T> & { ref?: Ref<RefSelectProps> }>>
        ref={selectRef}
        suffix={suffix}
        {...selectProps}
      />
      {suffix && <Suffix value={suffix} />}
    </div>
  );
}

Select.Option = AntdSelect.Option;
